import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-currency',
  templateUrl: './currency.component.html',
})
export class CurrencyComponent {
  @Input() value = 0;
  @Input() normal = false;

  integer() {
    return Math.floor(this.value / 100).toLocaleString(undefined, { currency: 'AUD' });
  }

  decimal() {
    return Math.abs(this.value % 100).toString().padStart(2, '0');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/currency/currency.component.ts